module.exports = __webpack_public_path__ + "static/media/sandpaper.fe057eaa.png";